/**
 * OneTrophy - <ot-scroller> : carrousel natif base sur le defilement horizontal (scroll-snap).
 *
 * Structure attendue :
 *   <ot-scroller data-autoplay="6000">
 *     <div data-ot-track> ...elements... </div>
 *     <button data-ot-prev> <button data-ot-next>   (optionnels)
 *     <button data-ot-dot="0"> ...                   (optionnels)
 *   </ot-scroller>
 *
 * Sans JavaScript, la piste reste defilable au doigt ou a la molette. L'autoplay est desactive si l'utilisateur
 * prefere reduire les animations, et se met en pause au survol, au focus et quand l'onglet est masque.
 */
if (!customElements.get('ot-scroller')) {
  class OtScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ot-track]');

      if (!this.track) {
        return;
      }

      this.items = Array.from(this.track.children);
      this.prevButton = this.querySelector('[data-ot-prev]');
      this.nextButton = this.querySelector('[data-ot-next]');
      this.dots = Array.from(this.querySelectorAll('[data-ot-dot]'));

      this.prevButton?.addEventListener('click', () => this.step(-1));
      this.nextButton?.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.otDot))));

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.onScroll();

      const delay = Number(this.dataset.autoplay || 0);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (delay > 0 && !reduced && this.items.length > 1) {
        this.startAutoplay(delay);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    get index() {
      const left = this.track.scrollLeft;
      let closest = 0;

      this.items.forEach((item, i) => {
        if (Math.abs(item.offsetLeft - this.track.offsetLeft - left) < Math.abs(this.items[closest].offsetLeft - this.track.offsetLeft - left)) {
          closest = i;
        }
      });

      return closest;
    }

    goTo(i) {
      const item = this.items[(i + this.items.length) % this.items.length];
      this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }

    step(direction) {
      if (this.dots.length > 0) {
        // Bannieres : une diapositive a la fois, en boucle
        this.goTo(this.index + direction);
      } else {
        // Rangees de produits : on avance d'une "page" visible
        this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9, behavior: 'smooth' });
      }
    }

    onScroll() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;

      if (this.prevButton && this.dots.length === 0) {
        this.prevButton.disabled = this.track.scrollLeft <= 2;
      }

      if (this.nextButton && this.dots.length === 0) {
        this.nextButton.disabled = this.track.scrollLeft >= max;
      }

      const current = this.index;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
    }

    startAutoplay(delay) {
      const play = () => {
        clearInterval(this.timer);
        this.timer = setInterval(() => this.step(1), delay);
      };
      const pause = () => clearInterval(this.timer);

      this.addEventListener('pointerenter', pause);
      this.addEventListener('pointerleave', play);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', () => (document.hidden ? pause() : play()));

      play();
    }
  }

  customElements.define('ot-scroller', OtScroller);
}
